<mat-card-header>
  <div style="width:90%">
    <mat-card-title>
      <label class="mat-h2 bold">{{data.title}}</label>
    </mat-card-title>
  </div>
  <div style="width:10%; cursor:pointer;" *ngIf="data.type != 'warning'">
    <mat-icon class="btnCancel" style="position: relative; float: right;" (click)="closePopup()">cancel</mat-icon>
  </div>
</mat-card-header>
<mat-card-content class="divAutoScroll">
  <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="15%">
    <div class="divAutoScroll">
      {{data.subtitle}} 
    </div>
  </div>
  <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="11%">
    <div class="mat-h4 bold">
        <div [innerHTML]="htmlStr"></div>
      <button *ngIf="downloadSavePrint" (click)='getSavePrint()' mat-button>Veja como fazer</button>
    </div>
  </div>
</mat-card-content>
<mat-action-row class="footer">
    <button mat-button color="warn"  *ngIf="confirm"  (click)="notConfirm()">Não</button>
  <button id="btnTipoDoc" mat-button color="primary" class="btn-primary" (click)="Confirm()">{{textButton}}</button>
</mat-action-row>